import { Component } from '@angular/core';

@Component({
  selector: 'app-land-and-building-register-data-update-upon-entities-request',
  templateUrl:
    './land-and-building-register-data-update-upon-entities-request.component.html',
  standalone: false,
})
export class LandAndBuildingRegisterDataUpdateUponEntitiesRequestComponent {}
